'use strict';

import { SOLUTION_TYPE } from '../shared/constants/user-info/solutionType';

(function () {
  angular
    .module('app.preCheckInProceed', [])
    .config(registrationChildConfig);

  registrationChildConfig.$inject = ['$routeProvider'];

  function registrationChildConfig($routeProvider) {
    $routeProvider.when('/proceed-pre-check-in-registration/:token', {
      template: '<ngz-proceed-registration />',
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
      },
    });
  }
})();
